/**
 * 语音质检类型定义 - 基于ACE CX QA Culture Rubric
 */

export type Utterance = {
  speaker: 'agent' | 'customer';
  text: string;  // 原文
  textCn: string;  // 中文翻译（如果原文非中文）
  language: string;  // 语言代码
  politePhrases: string[];
  rudePhrases: string[];
};

/** ACE单项评分 */
export type ACECriterionScore = {
  id: number;
  name: string;
  score: number;
  passed: boolean;
  comment: string;
};

/** ACE类别评分 */
export type ACECategoryScore = {
  category: 'Accurate' | 'Customized' | 'Efficient';
  score: number;
  criteria: ACECriterionScore[];
};

/** 语音质检分析结果 - 基于ACE评价体系 */
export type VoiceQcAnalysis = {
  // 综合评分
  overallScore: number;
  
  // ACE三大维度评分
  accurateScore: number;
  customizedScore: number;
  efficientScore: number;
  
  // ACE详细评分
  aceScores: ACECategoryScore[];
  
  // ZTP零容忍政策
  ztpViolation: boolean;
  ztpDetails: string;
  
  // 语言信息
  detectedLanguage: string;
  
  // 检测结果
  politePhrases: string[];
  missingPolitePhrases: string[];
  rudePhrases: string[];
  
  // 总结与建议
  summary: string;
  suggestions: string[];
  sentiment: 'positive' | 'neutral' | 'negative';
  dialogueFlow: string;
  
  // 对话时间线
  timeline: Utterance[];
  transcription?: string;
};

/** ACE评价体系类别中文名映射 */
export const ACE_CATEGORY_NAMES: Record<string, string> = {
  'Accurate': '准确性',
  'Customized': '个性化',
  'Efficient': '高效性'
};

/** ACE评价体系类别描述 */
export const ACE_CATEGORY_DESCRIPTIONS: Record<string, string> = {
  'Accurate': '评估信息准确性、流程合规性和问题解决能力',
  'Customized': '评估服务个性化程度、客户关怀和沟通技巧',
  'Efficient': '评估服务效率、资源利用和问题解决速度'
};

/** 语言代码映射 */
export const LANGUAGE_NAMES: Record<string, string> = {
  'zh': '中文',
  'en': '英语',
  'ko': '韩语',
  'ja': '日语',
  'es': '西班牙语',
  'fr': '法语',
  'de': '德语'
};
